import React from "react";
import { MERGE_TAG_KEYS } from "../domain/merge-tags";
import { selectEmailSettings } from "../domain/selectors";
import { useEditorStore } from "../domain/store";
import type { ButtonBlock } from "../domain/types";
import { EmailBuilderRichTextEditor } from "../editing/richText/EmailBuilderRichTextEditor";
import { resolveInlineButtonLabelStyle } from "./inlineButtonBridge";

type InlineButtonLabelProps = {
  block: ButtonBlock;
};

export function InlineButtonLabel({
  block,
}: InlineButtonLabelProps) {
  const textTheme = useEditorStore(selectEmailSettings);

  return (
    <EmailBuilderRichTextEditor
      blockId={block.id}
      kind="label"
      content={block.text}
      fontWeight={block.fontWeight}
      editorClassName="email-builder-inline-button-label"
      editorStyle={resolveInlineButtonLabelStyle(block, textTheme)}
      ariaLabel={block.text}
      placeholder=""
      mergeTags={MERGE_TAG_KEYS}
      contentAttribute="data-email-builder-inline-button-label"
    />
  );
}
